import React from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
import MonthlySalesCommissionTable from "../../../components/table/all-tables/reportable/monthlysalescommision/MonthlySalesCommissionTable";
import { monthlyCommison } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

export default function MonthlySalesCommission() {
  return (
    <>
      <TablePagesTitle mainTitle={monthlyCommison.mainTitle} />

      <ReportPageAction subheading={monthlyCommison.mainTitle} />

      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <MonthlySalesCommissionTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
